import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Toast host for transient agent feedback (e.g. "Searching for card number…").
 *
 * Ported from the export's sonner wrapper; the export's `next-themes`
 * dependency is dropped (the agent desktop has no dark mode) in favour of a
 * fixed light theme using the PTSB popover tokens.
 */
function Toaster(props: ToasterProps): React.JSX.Element {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
